module.exports = __webpack_public_path__ + "img/individual_accident_button.5683f17f.png";